
import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { Router } from "@angular/router";
import { AuthService } from "@services/auth/auth-service";
import { ErrorTexts, JapaneseLabels } from "@utils/japaneseLabels";

/**
 * ForgetPassword component.
 * Handles the display and logic for the "Forget Password" page,
 * including form state, error handling, and sending password reset requests.
 */
@Component({
  selector: "app-forget-password",
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: "./forget-password.html",
  styleUrl: "./forget-password.scss",
})
export class ForgetPassword {

  /** Page title */
  title: string = "Forget Password";
  /** User's login ID for account recovery */
  account_login_id?: string;
  /** New password input */
  password!: string;
  /** Error message for password input */
  passwordError!: string;
  /** Error message for form submission */
  submitError!: string;
  /** Loading state for form submission */
  loading: boolean = false;
  /** Indicates if the reset email has been sent */
  sendMail: boolean = false;
  /** Japanese text labels */
  japaneseLabels = JapaneseLabels;
  /** Error text labels */
  errorTexts = ErrorTexts;

  /**
   * Constructs the ForgetPassword component.
   * 
   * @param router Angular Router for navigation
   * @param authenticateService Service for authentication and password reset
   */
  constructor(
    // private titleService: Title, //Service for setting the title of the page.
    private router: Router,
    private authenticateService: AuthService
  ) { }
  /**
   * Converts the account_login_id input to lowercase.
   * Useful for normalizing user input before submission.
   */
  ChangeToLower() {
    // this.account_login_id = this.account_login_id.toLowerCase();
  }
  /**
   * Converts the account_login_id input to lowercase.
   * Useful for normalizing user input before submission.
   */
  accountLoginId() {

  }
  /**
   * Converts the account_login_id input to lowercase.
   * Useful for normalizing user input before submission.
   */
  resetPassword() {

  }
  // accountLoginId() {
  // 	// eslint-disable-next-line no-restricted-syntax
  //   this.submitError = "";
  //   const account_login_id = this.account_login_id.trim();
  //   this.account_login_id = this.account_login_id.trim();
  //   const forgetData = { account_login_id };
  //   this.loading = true;
  //   this.authenticateService.forgetPassword(forgetData).subscribe({
  //     next: (res) => {
  //       if (res.status === 200) {
  //         this.sendMail = true;
  //       }
  //       this.loading = false;
  //     },
  //     error: (err) => {
  //       console.error("request failed:", err.error);
  //       this.loading = false;
  //       if (err.status === 404) {
  //         this.sendMail = false;
  //       }
  //       this.submitError = "※認証に失敗しました"; // if fails Set the error message
  //     },
  //   });
  // }
  // resetPassword() {
  //   const one_time_password = this.password.trim();
  //   const account_login_id = this.account_login_id;
  //   const oneTimePassword = { account_login_id, one_time_password };
  //   this.loading = true;
  //   this.authenticateService.oneTimePassword(oneTimePassword).subscribe({
  //     next: (res) => {
  //       const reset_token = res.body.reset_token;
  //       if (res.status === 200) {
  //         this.sendMail = false;
  // 				// eslint-disable-next-line no-restricted-syntax
  //         this.passwordError = "";
  //         // redirect to URL with reset token in state
  //         this.router.navigate([AppRoutes.RESET_PASSWORD], {
  //           state: {
  //             resetToken: reset_token,
  //           },
  //         });
  //       }
  //       this.loading = false;
  //     },
  //     error: (err) => {
  //       console.error("request failed:", err.error);
  //       this.loading = false;
  //       this.passwordError = "※認証に失敗しました"; // if fails Set the error message
  //     },
  //   });
  // }
}
